import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { CommonService } from 'src/app/shared/services/common.service';

@Component({
	selector: 'app-device-attachments',
	templateUrl: './device-attachments.component.html',
	styleUrls: ['./device-attachments.component.css']
})
export class DeviceAttachmentsComponent implements OnInit {

	@Input() device: any;
	@Input() currentSite: any = {};

	macAddress: string = '';
	source: string = 'device';

	constructor(
		private commonService: CommonService,
		private translateService: TranslateService
	) { }

	ngOnInit() {}
	
	ngOnChanges() {
		this.macAddress = this.device.mac_address;
		this.commonService.setPageTabTitle(`${this.currentSite.customer_name} - ${this.currentSite.name} - ${this.device.serial_number} - ${this.translateService.instant('attachments.device')}`);
	}
}
